import React, { useContext, useEffect, useState } from 'react';
import { PropertyContext, TourPage, TourSignupProps } from './TourRouter';
import { TourNavigationButtons } from './TourStateMachine';
import { withRouter } from 'react-router-dom';
import '../../../../styles/CreditCardInput.css';
import {
    addPaymentMethod,
    updatePaymentMethod,
    getPaymentMethod
} from '../../../../api/ProspectUserProfile';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../common/LoadingOverlay';
import { useFetch } from '../../../../hooks/useFetch';
import CreditCardForm from '../../../common/form/CreditCardForm';
import Button from '../../../common/form/Button';
import { isCreditCardExpired } from '../../../../utilities/Utils';
import { formatCreditCardExpiration } from '../../../../utilities/formatting';
import {
    PageProgress,
    ProspectVerificationStatus,
    ProspectVerificationType,
    updatePageProgress,
    updateProspectVerificationStatus
} from '../../../../api/TourSignup';

const CreditCardPage = (props: TourSignupProps) => {
    useEffect(() => {
        if (props.match.params.guestCardGuid !== undefined) {
            updatePageProgress(
                props.match.params.guestCardGuid,
                PageProgress.CreditCardVerification
            );
        }
    }, []);

    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const {
        data: creditCard,
        setData: setCreditCard,
        loading,
        setLoading,
        error,
        setError
    } = useFetch(getPaymentMethod, [], undefined);
    const [updateCreditCard, setUpdateCreditCard] = useState(false);

    const captureToken = async (tokenId: string) => {
        const saveResult = await (updateCreditCard
            ? updatePaymentMethod(tokenId)
            : addPaymentMethod(tokenId));
        if (saveResult.error || !saveResult.data) {
            if (props.match.params.guestCardGuid) {
                updateProspectVerificationStatus(props.match.params.guestCardGuid, {
                    verificationType: ProspectVerificationType.CreditCard,
                    verificationStatus: ProspectVerificationStatus.Failed
                });
            }
            setError(saveResult.error || 'Failed to save payment'+`. \nIf you need additional support please email 888-297-7411, or call support@tour24.io.`);
            return;
        }

        if (props.match.params.guestCardGuid) {
            updateProspectVerificationStatus(props.match.params.guestCardGuid, {
                verificationType: ProspectVerificationType.CreditCard,
                verificationStatus: ProspectVerificationStatus.Succeeded
            });
            setError(undefined);
        }

        setCreditCard(saveResult.data);
        setUpdateCreditCard(false);
    };

    return (
        <div className="schedule-form clearfix">
            <h3 className="prospect-signup-header">You're almost there! One last step.</h3>
            <LoadingOverlay show={loading} inBootstrapColumn={true} />
            <FormValidationDisplay errorMessage={error} />
            {!creditCard || updateCreditCard ? (
                <CreditCardForm
                    updateCreditCard={updateCreditCard}
                    setLoading={setLoading}
                    handleRedeemFailed={(e: string) => {
                        setError(e+".\nIf you need additional support please email 888-297-7411, or call support@tour24.io.");
                        if (props.match.params.guestCardGuid && !updateCreditCard) {
                            updateProspectVerificationStatus(props.match.params.guestCardGuid, {
                                verificationType: ProspectVerificationType.CreditCard,
                                verificationStatus: ProspectVerificationStatus.Failed
                            });
                        }
                    }}
                    captureToken={captureToken}
                />
            ) : (
                <div>
                    <p className="font-weight-bold pb-2">
                        {isCreditCardExpired(creditCard.expirationDate) ? (
                            <span>
                                The {creditCard.cardBrand} card ending in{' '}
                                {creditCard.lastFourDigits} we have on file for you expired{' '}
                                {formatCreditCardExpiration(creditCard.expirationDate)}. Please
                                select Update credit card below to update it.
                            </span>
                        ) : (
                            <span>
                                We have a {creditCard.cardBrand} ending in{' '}
                                {creditCard.lastFourDigits} on file for you (expires{' '}
                                {formatCreditCardExpiration(creditCard.expirationDate)}). If you
                                would like to update your billing information to use a different
                                credit card then click Update credit card below. If your card on
                                file is correct, hit Next to continue with the signup process.
                            </span>
                        )}
                    </p>
                    <Button text="Update credit card" onClick={() => setUpdateCreditCard(true)} />
                    <br />
                    <TourNavigationButtons props={props} page={TourPage.CcQualification} />
                </div>
            )}
        </div>
    );
};

export default withRouter(CreditCardPage);



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/CreditCardPage.tsx